import React from 'react'
import Button from './index'

const FavoriteButton = ({ isFavorite, onclick }) => {
  return (
    <Button
      type="button"
      btnClass="btn-icon"
      iconRight
      iconSize="1rem"
      iconClass={isFavorite ? 'pi pi-star-fill' : 'pi pi-star'}
      onHandleClick={onclick}
    />
  )
}

export default FavoriteButton
